export type europeanaCountries = string[];

export const europeanaCountries: europeanaCountries = [
    "BE-VAN",
    "BE-WAL",
    "CZ",
    "DK",
    "DE",
    "EE",
    "IE",
    "ES",
    "FR",
    "HR",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "AT",
    "PL",
    "PT",
    "RO",
    "SI",
    "SK",
    "FI",
    "SE",
    "*ME",
    "*UA"
];

const hiddenPseudoMoMCountryLabels = new Set(["CY", "EL", "HU"]);

export function shouldShowPseudoMoMCountryLabel(countryCode: string): boolean {
    return !hiddenPseudoMoMCountryLabels.has(String(countryCode || "").trim().toUpperCase());
}
